import React from 'react';

import { capitalize } from 'lodash';

import { Premium, Standard } from '@portal/components/shared/icons';
import {
  Pricing__Plan__ProtectionClassification,
  PricingSetPriceEntryFragment,
  ProtectionPlanFragment,
} from '@portal/schema';

import { Options } from '../options';
import { currency, protectionPlanSlug, PROTECTION_PLAN_SLUG_1000_INCLUDED } from '../util';

const ProtectionIcon = {
  [Pricing__Plan__ProtectionClassification.Standard]: Standard,
  [Pricing__Plan__ProtectionClassification.Premium]: Premium,
};

export interface ProtectionOptionProps {
  option: PricingSetPriceEntryFragment;
  selected: boolean;
  onSelect(label: string): void;
  onRemove?(): void;
}

export const Option: React.FC<ProtectionOptionProps> = ({ option, selected, onSelect, onRemove }) => {
  const plan = option.price.plan as ProtectionPlanFragment;
  const slug = protectionPlanSlug(option);

  const title = plan.classification ? capitalize(plan.classification) : plan.name;

  const description = `Protects up to ${currency(plan.maxCovered)} of total item value.`;

  const priceLabel = slug === PROTECTION_PLAN_SLUG_1000_INCLUDED ? '$0' : `${currency(option.price.amount)}/mo`;
  const label = `${title} ${description}`;

  return (
    <Options.Card
      title={title}
      description={description}
      price={priceLabel}
      selected={selected}
      onSelect={() => onSelect(label)}
      onRemove={onRemove}
      icon={plan.classification ? ProtectionIcon[plan.classification] : Standard}
    />
  );
};
